"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const utils_1 = require("./utils");
const erc20_json_1 = __importDefault(require("./abis/erc20.json"));
const multicall_json_1 = __importDefault(require("./abis/multicall.json"));
class SwapContract {
    constructor(account, multicall, library) {
        this.library = library;
        this.account = account;
        this.multicallAddress = multicall;
    }
    useContract(address, ABI, withSignerIfPossible = true) {
        const library = this.library;
        const account = this.account;
        if (!address || !ABI || !library)
            return null;
        try {
            return (0, utils_1.getContract)(address, ABI, library, withSignerIfPossible && account ? account : undefined);
        }
        catch (error) {
            console.error("Failed to get contract", error);
            return null;
        }
    }
    useTokenContract(tokenAddress, withSignerIfPossible) {
        return this.useContract(tokenAddress, erc20_json_1.default, withSignerIfPossible);
    }
    useMulticallContract() {
        return this.useContract(this.multicallAddress, multicall_json_1.default, false);
    }
}
exports.default = SwapContract;
